import React, { useEffect, useState } from 'react'

import { Button, Typography } from '@telavita-core/react-design-kit'

import { ReactComponent as HeaderSvg } from 'static/svg/transcription-header-modal.svg'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import { useTranscriptionService } from 'services/me/preferences'
import { SimpleSuccessModal } from '../SimpleSuccessModal'
import { TranscriptionAuthorizerDisclaimerModal } from '../TranscriptionAuthorizerDisclaimerModal'

import * as S from './styles'

export interface TranscriptionAuthorizerModalProps {
  firstName: string
}

export const TranscriptionAuthorizerModal: React.FC<TranscriptionAuthorizerModalProps> = ({
  firstName,
}) => {

  const { data, mutate, isLoading, isError } = useTranscriptionService()

  const [showTranscriptionAuthorizerModal, setShowTranscriptionAuthorizerModal] = useState(false)
  const [showTranscriptionAuthorizeDisclaimerModal, setShowTranscriptionAuthorizeDisclaimerModal] = useState(false)
  const [showTranscriptionAuthorizeSuccessModal, setShowTranscriptionAuthorizeSuccessModal] = useState(false)

  useEffect(() => {
    if (!isLoading && !isError && data === null) {
      setShowTranscriptionAuthorizerModal(true)
    }
  }, [data, isLoading, isError])

  function onAccept() {
    mutate(true)
    setShowTranscriptionAuthorizerModal(false)
    setShowTranscriptionAuthorizeDisclaimerModal(false)
    setShowTranscriptionAuthorizeSuccessModal(true)
  }

  function onDecline() {
    setShowTranscriptionAuthorizerModal(false)
    setShowTranscriptionAuthorizeDisclaimerModal(true)
  }

  if ((data === true || data === false) && !showTranscriptionAuthorizeSuccessModal) {
    return null
  }

  return (
    <>
      {showTranscriptionAuthorizerModal && (
        <ModalGeneric
          modalTitle=''
          topImage={<HeaderSvg />}
          hasCloseButton={false}
        >
          <S.TranscriptionAuthorizerModalContainer>
            <Typography variant='content1' weight='bolder'>
              Olá {firstName}!
            </Typography>

            <div>
              <Typography variant='content2' weight='normal'>
                <b>Para que seu tratamento seja cada vez mais completo</b> e eficiente, utilizamos a transcrição da consulta para registrar com mais riqueza de detalhes, no seu prontuário, tudo o que foi abordado. Isso ajuda seu psicólogo a ter uma visão mais precisa do seu processo e a oferecer um acompanhamento ainda mais alinhado às suas necessidades.
              </Typography>

              <Typography variant='content2' weight='normal'>
                Para que isso seja possível, <b>pedimos sua permissão para gravar temporariamente o áudio e a transcrição da sua consulta.</b> A gravação é segura, o áudio é automaticamente descartado após a transcrição e ninguém da equipe Telavita tem acesso a gravação.
              </Typography>

              <Typography variant='content2' weight='normal'>
                <b>Com sua autorização, conseguimos apoiar melhor o profissional que te acompanha</b> — e você ganha um cuidado ainda mais atento. Se estiver de acordo, é só confirmar sua permissão. Dúvidas? Fale conosco no chat!
              </Typography>
            </div>

            <S.ButtonsWrapper>
              <Button
                onClick={onDecline}
                uppercase={false}
                variant='outlined'
                id='decline-transcription-button'
                color='danger'
              >
                Não permitir
              </Button>

              <Button
                onClick={onAccept}
                uppercase={false}
                variant='contained'
                color='success'
                id='accept-transcription-button'
              >
                Permitir
              </Button>
            </S.ButtonsWrapper>
          </S.TranscriptionAuthorizerModalContainer>
        </ModalGeneric>
      )}

      {showTranscriptionAuthorizeDisclaimerModal && (
        <TranscriptionAuthorizerDisclaimerModal
          firstName={firstName}
          onClose={() => {
            mutate(false)
            setShowTranscriptionAuthorizeDisclaimerModal(false)
          }}
          onAccept={onAccept}
        />
      )}

      {showTranscriptionAuthorizeSuccessModal && (
        <SimpleSuccessModal
          title='Permissão registrada com sucesso'
          onClose={() => setShowTranscriptionAuthorizeSuccessModal(false)}
          hasButton
          buttonText='Fechar'
          onClick={() => setShowTranscriptionAuthorizeSuccessModal(false)}
        />
      )}
    </>
  )
}